import api from '../../../api/client';
import IncomeStatementList from "../../../components/accounts/incomeStatement";

const IncomeStatement = () => {
  return (
    <>
      <IncomeStatementList />
    </>
  );
};

export default IncomeStatement;
